<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="[$t('questionsview.unit_singular'), $t('questionsview.unit_plural'), $t('questionsview.unit_new')]"
			:pagination="pagination"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('questions_edit')"
			@toggleAdd="toggleAddQuestionGroup"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns" @click="closeAdd()">
			<QuestionGroupList
				:questionGroups="questionGroups"
				:activeQuestionGroup="activeQuestionGroup"
				@delete="askToDeleteQuestionGroup"
				@edit="editQuestionGroup"
				@search="getQuestionGroups()"
				@select="selectQuestionGroup"
				@navigate="navigate"
			/>
			<QuestionPanel
				v-if="activeQuestionGroup.id && !isMobile"
				:questions="activeQuestionGroup.questions"
				:questionGroup="activeQuestionGroup"
				@delete="askToDeleteQuestion"
				@edit="editQuestion"
				@add="toggleAddQuestion"
			/>
		</main>
		<AddGroup
			v-if="showAddQuestionGroup"
			@save="saveQuestionGroup"
			@cancel="closeAdd"
			:editQuestionGroup="selectedQuestionGroup"
		/>
		<addQuestion
			v-if="showAddQuestion"
			@cancel="closeAdd"
			@save="saveQuestion"
			:editQuestion="selectedQuestion"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import QuestionGroupList from './components/GroupList';
import QuestionPanel from './components/QuestionPanel';
import AddGroup from './modals/AddGroup';
import AddQuestion from './modals/AddQuestion';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		QuestionGroupList,
		QuestionPanel,
		AddGroup,
		AddQuestion,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAddQuestionGroup: false,
			showAddQuestion: false,
			showDelete: false,
			selectedQuestionGroup: {},
			activeQuestionGroup: {},
			selectedQuestion: {},
		};
	},
	computed: {
		...mapState('questionGroupStore', ['searchParams']),
		...mapState('questionStore', { questionSearchParams: 'searchParams' }),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('questionGroupStore', [
			'questionGroups',
			'questionGroup',
			'pagination'
		]),

		...mapGetters('user', ['getActiveCompany']),
		...mapGetters('questionStore', ['questions']),

		deleteMessage() {
			if (this.selectedQuestionGroup.name) {
				return this.$t('questionsview.confirm_delete_group', { name: this.selectedQuestionGroup.name });
			}
			if (this.selectedQuestion.name) {
				return this.$t('questionsview.confirm_delete_question', { name: this.selectedQuestion.name });
			}
			return '';
		},

		orderBys() {
			return [
				{ name: this.$t('common.order_name'), value: 'Name' },
				{ name: this.$t('common.order_created'), value: 'Created' }
			];
		},
	},

	watch: {
		'getActiveCompany.id'() {
			this.getQuestionGroups();
		}
	},

	methods: {
		...mapActions('questionGroupStore', [
			'getQuestionGroups',
			'getQuestionGroup',
			'createQuestionGroup',
			'updateQuestionGroup',
			'deleteQuestionGroup',
			'setCurrentPage',
			'setPageSize'
		]),
		...mapActions('questionStore', [
			'setQuestion',
			'getQuestions',
			'createQuestion',
			'updateQuestion',
			'deleteQuestion'
		]),

		toggleAddQuestionGroup() {
			if (!this.selectedQuestionGroup.name) {
				this.showAddQuestionGroup = !this.showAddQuestionGroup;
			}

			this.selectedQuestionGroup = {};
			this.showAddQuestion = false;
		},
		toggleAddQuestion(questionGroup) {
			this.showAddQuestion = !this.showAddQuestion;
			this.showAddQuestionGroup = false;
			this.selectedQuestionGroup = questionGroup;
			this.selectedQuestion = {};
		},
		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAddQuestionGroup = false;
				this.showAddQuestion = false;
				this.selectedQuestionGroup = {};
				this.selectedQuestion = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedQuestionGroup = {};
				this.selectedQuestion = {};
			}
		},
		saveQuestionGroup(questionGroup) {
			if (this.selectedQuestionGroup.id) {
				this.updateQuestionGroup(questionGroup).then(() => {
					this.showAddQuestionGroup = false;
					this.selectedQuestionGroup = {};
				});
			} else {
				this.createQuestionGroup(questionGroup).then(() => {
					this.showAddQuestionGroup = false;
				});
			}
		},
		editQuestionGroup(questionGroup) {
			if (this.selectedQuestionGroup == questionGroup) {
				this.selectedQuestionGroup = {};
				this.showAddQuestionGroup = false;
			} else {
				this.selectedQuestionGroup = questionGroup;
				this.showAddQuestionGroup = true;
				this.showAddQuestion = false;
			}
		},
		askToDeleteQuestionGroup(questionGroup) {
			this.showAddQuestion = false;
			this.showAddQuestionGroup = false;
			Object.assign(this.selectedQuestionGroup, questionGroup);
			this.showDelete = true;
		},
		askToDeleteQuestion(question) {
			this.showAddQuestion = false;
			this.showAddQuestionGroup = false;
			Object.assign(this.selectedQuestion, question);
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
			this.selectedQuestionGroup = {};
		},
		deleteSelected() {
			if (this.selectedQuestionGroup.name) {
				this.deleteQuestionGroup(this.selectedQuestionGroup).then(() => {
					this.showDelete = false;
					this.selectedQuestionGroup = {};
				});
			}

			if (this.selectedQuestion.name) {
				this.deleteQuestion(this.selectedQuestion).then(() => {
					this.getQuestionGroups();
					this.showDelete = false;
					this.selectedQuestionGroup = {};
				});
			}
		},
		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getQuestionGroups();
		},
		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getQuestionGroups();
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.getQuestionGroups();
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.getQuestionGroups();
		},
		selectQuestionGroup(questionGroup) {
			if (this.activeQuestionGroup.id == questionGroup.id) {
				this.activeQuestionGroup = {};
			} else {
				this.activeQuestionGroup = Object.assign({}, questionGroup);
			}

			this.questionSearchParams.questionGroupId = this.activeQuestionGroup.id;
			this.getQuestions();
		},
		saveQuestion(question) {
			if (this.selectedQuestion.id) {
				this.updateQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.selectedQuestion = {};
					this.getQuestionGroups();
					this.getQuestionGroup(this.activeQuestionGroup.id).then(() => {
						this.activeQuestionGroup = Object.assign({}, this.questionGroup);
					});
				});
			} else {
				question.questionGroupId = this.activeQuestionGroup.id;
				this.createQuestion(question).then(() => {
					this.showAddQuestion = false;
					this.getQuestionGroups();
					this.getQuestionGroup(question.questionGroupId).then(() => {
						this.activeQuestionGroup = Object.assign({}, this.questionGroup);
					});
				});
			}
		},
		editQuestion(question) {
			if (this.selectedQuestion == question) {
				this.selectedQuestion = {};
				this.showAddQuestion = false;
			} else {
				this.selectedQuestion = question;
				this.showAddQuestion = true;
				this.showAddQuestionGroup = false;
			}
		},
		navigate(groupId) {
			this.$router.push({
				name: 'QuestionsDetailView',
				params: { questionGroupId: groupId }
			});
		}
	},
	created() {
		this.getQuestionGroups();
	}
};
</script>
